import Holidays from "../Holidays";
import ELayout from "./ELayout";
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ArrowLeftCircle } from "react-bootstrap-icons";
const EHolidays = () => {
    const navigate = useNavigate();

    return (
        <ELayout heading={
              <div className="mb-3 d-flex align-items-center">
              <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
                <ArrowLeftCircle />
              </Button>
              
              <span className="ms-3">Holidays</span> {/* ms-3 adds margin to the left of the span */}
            </div>    
            }>
             <Holidays/>
        
        </ELayout>
    );
};

export default EHolidays;
